export default "<p>\n  adm-blog works!\n</p>\n\n<ul *ngFor=\"let blog of blogList\">\n  <li>{{blog.blogTitle}}</li>\n</ul>\n";